import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import ReactSelect from 'components/theme/Select'
import { FormHelperText, Checkbox } from '@material-ui/core'
import { selectFromNumber, toggleManagePhonesModal } from 'actions/tasks'
import { handleFieldChange } from 'actions/tasks'
import { list } from 'actions/data'
import { createSelector } from 'reselect'

const getPhoneUseCase = createSelector(
  [
    state => Object.values(state.data.a2p10dlc || {})?.[0]?.messagingServices || {},
    state => Object.values(state.data.a2p10dlc || {})?.[0]?.phones || {},
    (_, numberObj) => numberObj,
  ],
  (messagingServices, phones, numberObj) => {
    const phone = phones[numberObj?.phone_number_sid]
    const serviceSid = phone?.serviceSid
    
    if (!serviceSid) return null
    
    // Find the use case name from messagingServices
    const useCase = Object.entries(messagingServices).find(
      ([_, service]) => service.sid === serviceSid
    )
    
    return useCase ? useCase[0].replace(/_/g, ' ') : null
  },
)

const selectValue = (number, numberObj, users, useCase) => {
  const user = users?.[numberObj?.vast_user_name]
  const userLabel = user ? ` — ${user.first_name} ${user?.last_name?.slice?.(0, 1)}.` : ''
  const useCaseLabel = useCase ? ` (${useCase})` : ''

  return number
    ? {
        value: number,
        label: `${number?.slice?.(0, 2)} (${number?.slice?.(2, 5)}) ${number?.slice?.(
          5,
          8,
        )}-${number?.slice?.(8)}${userLabel}${useCaseLabel}`,
        key: `PhoneNumberSelectValue${number}`,
      }
    : null
}

export const UseOwnerFrom = connect(
  (state, { type }) => {
    return {
      checked: state.tasks.addOrEdit.fields?.[type]?.value,
    }
  },
  dispatch => bindActionCreators({ handleFieldChange }, dispatch),
)(({ disabled, checked, handleFieldChange, type }) => (
  <>
    <Checkbox
      disabled={disabled}
      checked={checked}
      onChange={e => handleFieldChange(type, e?.target?.checked)}
    />
    <span style={{ fontSize: 14 }}>
      Send from contact's assigned user's{' '}
      {type === 'use_owner_from_number' ? 'phone number' : 'email address'} if
      available
    </span>
  </>
))

export default connect(
  state => {
    const task = state.tasks.tasksByID[state.tasks.addOrEdit.taskID]
    const stats = task?.sms_stats || task?.email_stats
    const campaignStatus =
      state.tasks.addOrEdit.originalCampaignSelected?.campaign?.status
    const automationTypeSelected = state.tasks.addOrEdit.automationTypeSelected
    const disabled = Boolean(
      (stats && automationTypeSelected !== 'stage') ||
        campaignStatus === 'L' ||
        campaignStatus === 'C',
    )

    const users = state.data['account/user']
    const phonenumbers = state.data.phonenumbers
    const phonenumbersByNumber = Object.values(phonenumbers || {}).reduce(
      (acc, val) => {
        acc[val.phone_number] = val
        return acc
      },
      {},
    )
    const valueRaw = state.tasks.addOrEdit.fromNumberSelected.value
    const selectedNumberObj = phonenumbersByNumber[valueRaw]
    const useCase = selectedNumberObj ? getPhoneUseCase(state, selectedNumberObj) : null

    return {
      value: selectValue(valueRaw, selectedNumberObj, users, useCase),
      error: state.tasks.addOrEdit.fromNumberSelected.error,
      phoneNumbersOptions: phonenumbers
        ? Object.values(phonenumbers).map(numberObj =>
            selectValue(
              numberObj.phone_number, 
              numberObj, 
              users,
              getPhoneUseCase(state, numberObj)
            ),
          )
        : [],
      disabled,
      loadStatus: state.loadStatus.phonenumbers,
      userLoadStatus: state.loadStatus.users,
    }
  },
  dispatch =>
    bindActionCreators(
      { selectFromNumber, toggleManagePhonesModal, list },
      dispatch,
    ),
)(
  ({
    value,
    error,
    phoneNumbersOptions,
    selectFromNumber,
    toggleManagePhonesModal,
    disabled,
    loadStatus,
    list,
    userLoadStatus,
  }) => {
    if (!loadStatus) {
      list('phonenumbers')
    }

    if (!userLoadStatus) {
      list('account/user', 'user_name')
    }

    const customStyles = {
      control: provided => ({
        ...provided,
        borderColor: error ? '#f44336' : 'rgba(0, 0, 0, 0.23)',
        borderRadius: '28px',
        padding: '9px 0',
      }),
      menu: provided => ({
        ...provided,
        zIndex: 2,
      }),
    }

    return (
      <>
        <div style={{ marginBottom: 8 }}>
          <FormHelperText
            // TODO: Remove this for non account owners
            style={{
              marginTop: 0,
              marginBottom: 4,
              textDecoration: 'underline',
              color: '#0000ee',
              cursor: 'pointer',
            }}
            onClick={() => toggleManagePhonesModal()}
          >
            Manage phones
          </FormHelperText>
          <ReactSelect
            styles={customStyles}
            value={value}
            onChange={newValue => selectFromNumber(newValue)}
            closeMenuOnSelect={false}
            options={phoneNumbersOptions}
            placeholder="Select a phone number to send this SMS"
            isDisabled={disabled}
            // isOptionDisabled={(option) =>
            //   Boolean(phonenumbers.find((number) => number === option.value))
            // }
          />
          <FormHelperText error={Boolean(error)}>
            {error || 'Send from the phone number selected above'}
          </FormHelperText>
        </div>
        <div>
          <UseOwnerFrom disabled={disabled} type="use_owner_from_number" />
        </div>
      </>
    )
  },
)
